import { render, staticRenderFns } from "./OtherIncomeList.vue?vue&type=template&id=586c6e0d"
import script from "./OtherIncomeList.vue?vue&type=script&lang=js"
export * from "./OtherIncomeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports